enum ReportSmsCampaign {
  None = 0,
  Invitation = 1,
  InvitationReceipt = 2,
  SignatureRemoved = 3,
  NextSignerNotification = 4,
  WaitingForNextSignerNotification = 5,
}
enum ReportEmailCampaign {
  None = 0,
  Invitation = 1,
  SignatureConfirmed = 2,
  LinkAccidentReportFromConfirmation = 3,
}
interface SmsReportLinkSource {
  medium: "sms";
  campaign: keyof typeof ReportSmsCampaign;
}
interface EmailReportLinkSource {
  medium: "email";
  campaign: keyof typeof ReportEmailCampaign;
}
export type ReportLinkSource = SmsReportLinkSource | EmailReportLinkSource;

export function getReportLinkSourceFromShortParams(
  search: string,
): ReportLinkSource | null {
  const params = new URLSearchParams(search);
  const smsCampaign = params.get("sms");
  if (smsCampaign) {
    const campaign = Number(smsCampaign);
    const campaignEntry = Object.entries(ReportSmsCampaign).find(
      ([, value]) => value === campaign,
    );
    if (campaignEntry) {
      return {
        medium: "sms",
        campaign: campaignEntry[0] as keyof typeof ReportSmsCampaign,
      };
    }
  }

  const emailCampaign = params.get("email");
  if (emailCampaign) {
    const campaign = Number(emailCampaign);
    const campaignEntry = Object.entries(ReportEmailCampaign).find(
      ([, value]) => value === campaign,
    );
    if (campaignEntry) {
      return {
        medium: "email",
        campaign: campaignEntry[0] as keyof typeof ReportEmailCampaign,
      };
    }
  }

  return null;
}

export interface UtmCampaign {
  // utm_source
  source: "naf-skademelding";
  // utm_medium
  medium: `skademelding-${Lowercase<string>}`;
  // utm_campaign
  name: `skademelding-${Lowercase<string>}`;
}

function toKebabCase(str: string) {
  return str
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .toLowerCase() as Lowercase<string>;
}

export function toUtmCampaign(linkSource: ReportLinkSource): UtmCampaign {
  return {
    source: "naf-skademelding",
    medium: `skademelding-${linkSource.medium}`,
    name: `skademelding-${toKebabCase(linkSource.campaign)}`,
  };
}

export function addUtmCampaign(
  params: URLSearchParams,
  campaign: UtmCampaign,
): URLSearchParams {
  const next = new URLSearchParams(params);
  next.set("utm_source", campaign.source);
  next.set("utm_medium", campaign.medium);
  next.set("utm_campaign", campaign.name);
  return next;
}
